import { render, staticRenderFns } from "./ConfigRegionPager.vue?vue&type=template&id=622205e8&scoped=true&"
import script from "./ConfigRegionPager.vue?vue&type=script&lang=js&"
export * from "./ConfigRegionPager.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRegionPager.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConfigRegionPager.vue?vue&type=style&index=1&id=622205e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622205e8",
  null
  
)

export default component.exports